/**
 * Dicionário PT → EN.
 * As strings em Português do app são as CHAVES; o valor é a tradução em inglês.
 * Quando lang === "pt", o t() retorna a própria chave (sem lookup).
 * Chaves ausentes caem no fallback (texto PT original).
 */
export const EN = {
  // ── Navegação / AdminLayout ────────────────────────────────────────────
  "Resumo do dia": "Today's Summary",
  "Agenda": "Schedule",
  "Liberação da agenda": "Schedule Release",
  "Cadastros": "Records",
  "Clientes": "Clients",
  "Solicitações": "Requests",
  "Equipe": "Team",
  "Colaboradores": "Collaborators",
  "Equipes": "Teams",
  "Cargos": "Positions",
  "Estoque": "Inventory",
  "Equipamentos": "Equipment",
  "Itens de limpeza": "Cleaning Supplies",
  "Financeiro": "Finance",
  "Pagamentos": "Payments",
  "Recebimentos": "Receivables",
  "Relatórios financeiros": "Financial Reports",
  "Histórico de pagamentos": "Payment History",
  "Relatórios gerais": "General Reports",
  "Histórico": "History",
  "Pessoal": "Personal",
  "Minhas notas": "My Notes",
  "Comunicação": "Communication",
  "Notificações": "Notifications",
  "Templates de mensagem": "Message Templates",
  "Histórico de envios": "Sent History",
  "Configurações": "Settings",
  "Dados da Empresa": "Company Info",
  "Cores": "Colors",
  "Editar perfil →": "Edit profile →",
  "Instalar app": "Install app",
  "Sair": "Log out",
  "Fechar menu": "Close menu",
  "Abrir menu": "Open menu",
  "Relatórios": "Reports",
  "itens requerendo atenção": "items needing attention",

  // ── Status / Papéis ────────────────────────────────────────────────────
  "Agendada": "Scheduled",
  "Em deslocamento": "In Transit",
  "Em andamento": "In Progress",
  "Finalizada": "Finished",
  "Cancelada": "Canceled",
  "Atrasada": "Late",
  "Dia concluído": "Day Complete",
  "Horário inválido": "Invalid Time",
  "Administrador": "Administrator",
  "Supervisão": "Supervisor",
  "Colaborador": "Collaborator",
  "URGENTE": "URGENT",
  "MÉDIA": "MEDIUM",
  "BAIXA": "LOW",

  // ── Comuns ─────────────────────────────────────────────────────────────
  "Carregando…": "Loading…",
  "Voltar": "Back",
  "Hoje": "Today",
  "Amanhã": "Tomorrow",
  "Ontem": "Yesterday",
  "Editar": "Edit",
  "Abrir": "Open",
  "Atualizar": "Refresh",
  "opcional": "optional",
  "Falha": "Failed",

  // ── Login ──────────────────────────────────────────────────────────────
  "Operações de limpeza": "Cleaning Operations",
  "Bem-vindo de volta": "Welcome back",
  "Entre no seu painel.": "Sign in to your dashboard.",
  "Acesse sua conta para gerenciar equipes, agenda e financeiro — ou iniciar sua próxima limpeza com geofence em tempo real.":
    "Access your account to manage teams, schedule and finances — or start your next cleaning with real-time geofence.",
  "Painel administrativo:": "Admin dashboard:",
  "agenda, clientes, equipes, financeiro e relatórios.": "schedule, clients, teams, finances and reports.",
  "App de campo:": "Field app:",
  "suas limpezas do dia, check-in com GPS, fotos antes/depois.": "your cleanings for the day, GPS check-in, before/after photos.",
  "E-mail": "Email",
  "Senha": "Password",
  "Esqueci minha senha": "Forgot my password",
  "Ocultar senha": "Hide password",
  "Mostrar senha": "Show password",
  "Esqueceu a senha? Recupere por e-mail em 1 minuto.": "Forgot your password? Recover it by email in 1 minute.",
  "Recuperar agora →": "Recover now →",
  "Entrando…": "Signing in…",
  "Entrar": "Sign in",
  "ou": "or",
  "Entrar com Google": "Sign in with Google",
  "Ainda não tem conta?": "Don't have an account yet?",
  "Criar empresa grátis →": "Create your company free →",
  "Login seguro": "Secure login",
  "Agenda ao vivo": "Live schedule",
  "Sua operação de limpeza,": "Your cleaning operation,",
  "organizada e no controle.": "organized and under control.",
  "Agenda, equipes, GPS, fotos antes/depois e relatórios — em um único painel pensado para celular e desktop.":
    "Schedule, teams, GPS, before/after photos and reports — in a single dashboard built for mobile and desktop.",
  "Raio de geofence": "Geofence radius",
  "Funciona offline": "Works offline",
  "Acesso em campo": "Field access",
  "Sistema operacional · v2026": "System operational · v2026",
  "Limpeza profissional": "Professional cleaning",
  "Banheiro brilhando": "Sparkling bathroom",
  "Ambiente arejado": "Fresh airy space",
  "Pronto para o cliente": "Ready for the client",
  "E-mail ou senha inválidos": "Invalid email or password",
  'Esta conta é de colaborador. Use a aba "Colaborador" para acessar o app de campo.':
    'This is a collaborator account. Use the "Collaborator" tab to access the field app.',
  'Esta conta é administrativa. Use a aba "Admin / Supervisor" para acessar o painel.':
    'This is an admin account. Use the "Admin / Supervisor" tab to access the dashboard.',
  "Bem-vindo(a), {name}": "Welcome, {name}",

  // ── Dashboard ──────────────────────────────────────────────────────────
  "Painel operacional": "Operations Dashboard",
  "Limpezas hoje": "Cleanings Today",
  "Finalizadas": "Finished",
  "Equipes ativas": "Active Teams",
  "Faturamento hoje": "Revenue Today",
  "cliente em atraso": "client overdue",
  "clientes em atraso": "clients overdue",
  "a receber": "to collect",
  "Ver detalhes →": "View details →",
  "suprimento no/abaixo do estoque mínimo": "supply at/below minimum stock",
  "suprimentos no/abaixo do estoque mínimo": "supplies at/below minimum stock",
  "Repor →": "Restock →",
  "Mapa das casas registradas": "Map of Registered Homes",
  "clientes": "clients",
  "Abrir mapa completo →": "Open full map →",
  "Nenhum cliente com GPS capturado ainda.": "No clients with GPS captured yet.",
  "Equipes finalizadas hoje": "Teams Finished Today",
  "Ver todas →": "View all →",
  "Nenhuma equipe cadastrada.": "No teams registered.",
  "Nenhuma equipe com casas atribuídas para hoje.": "No teams with homes assigned for today.",
  "✓ Concluído": "✓ Done",
  "casas finalizadas": "homes finished",
  "Em campo": "In the field",
  "casas": "homes",
  "Limpezas de hoje": "Today's Cleanings",
  "Ver agenda completa →": "View full schedule →",
  "Nenhuma limpeza agendada para hoje.": "No cleanings scheduled for today.",
  "Horário": "Time",
  "Cliente": "Client",
  "Ação": "Action",
  "contrato": "contract",
  "contratos": "contracts",
  "vencido(s) ou": "overdue or",
  "expirando em 30 dias": "expiring within 30 days",
  "Receita recorrente em risco:": "Recurring revenue at risk:",
  "/limpeza": "/cleaning",
  "Vencido há {n}d": "Overdue by {n}d",
  "Vence hoje": "Due today",
  "{n}d restantes": "{n}d left",
  "Ver todos ({n}) →": "View all ({n}) →",

  // ── Widgets do Dashboard ───────────────────────────────────────────────
  "Saúde da operação": "Operations Health",
  "Snapshot ao vivo · {pct}% concluído hoje": "Live snapshot · {pct}% completed today",
  "atualiza a cada 30s": "refreshes every 30s",
  "Atrasados": "Late",
  "Em 30min": "In 30min",
  "Concluídos": "Done",
  "Operadores ativos": "Active Operators",
  "Atrasados agora ({n})": "Late right now ({n})",
  "{n}min atrasado": "{n}min late",
  "Próximos 30 min ({n})": "Next 30 min ({n})",
  "em {n}min": "in {n}min",
  "Tendência financeira · últimos 30 dias": "Financial trend · last 30 days",
  "Tendência financeira · últimos {n} meses": "Financial trend · last {n} months",
  "em {m}": "in {m}",
  "vs mês anterior": "vs previous month",
  "30 dias": "30 days",
  "Receita": "Revenue",
  "Custos": "Costs",
  "Lucro": "Profit",

  // ── Mobile (colaborador) ───────────────────────────────────────────────
  "Olá,": "Hello,",
  "Modo Foco — só o trabalho atual": "Focus Mode — current job only",
  "Sua agenda será liberada às {time}": "Your schedule will be released at {time}",
  "Aguarde o horário de liberação. Quando chegar, suas casas aparecem aqui automaticamente.":
    "Wait for the release time. When it arrives, your homes will appear here automatically.",
  "Esta semana": "This week",
  "Próximas casas": "Upcoming homes",
  "Avaliação grátis: {n} dias restantes": "Free trial: {n} days left",
  "Sua avaliação gratuita expirou": "Your free trial has expired",
  "Último dia da sua avaliação gratuita": "Last day of your free trial",
  "Assine agora para reativar o acesso completo.": "Subscribe now to restore full access.",
  "Assine um plano para continuar sem interrupções.": "Subscribe to a plan to keep going without interruptions.",
  "Assinar": "Subscribe",
  "feitas": "done",
  "Você não tem limpezas esta semana.": "You have no cleanings this week.",
  "Observações": "Notes",
  "← deslize para WhatsApp · deslize para mapa →": "← swipe for WhatsApp · swipe for map →",
  "deslize para mapa →": "swipe for map →",
  "Trabalho iniciado": "Job started",
  "Falha ao iniciar": "Failed to start",
  "GPS indisponível neste dispositivo": "GPS unavailable on this device",
  "Não foi possível obter sua localização": "Could not get your location",
  "Próximo trabalho": "Next job",
  "Quando chegar no local, toque em 'Cheguei na casa'": "When you arrive on site, tap 'I've arrived'",
  "Toque em 'Cheguei na casa' assim que estacionar": "Tap 'I've arrived' as soon as you park",
  "Limpeza em andamento": "Cleaning in progress",
  "Em andamento desde {time}": "In progress since {time}",
  "Validando GPS…": "Validating GPS…",
  "Cheguei na casa": "I've arrived",
  "Concluí a limpeza": "Cleaning completed",
  "Ver detalhes": "View details",
  "Traçar rota": "Get directions",

  // ── Kiosk (Modo Foco) ──────────────────────────────────────────────────
  "Sair do modo Foco": "Exit Focus mode",
  "Foco": "Focus",
  "Tudo certo!": "All clear!",
  "Você não tem nenhuma limpeza pendente no momento.": "You have no pending cleanings right now.",
  "● Em andamento": "● In progress",
  "Tocar para abrir no Google Maps →": "Tap to open in Google Maps →",
  "🔑 Código da porta": "🔑 Door Code",
  "CHEGUEI NA CASA": "I'VE ARRIVED",
  "FINALIZAR LIMPEZA": "FINISH CLEANING",
  "Abrir rota no mapa": "Open route in map",
  "Falha ao carregar trabalho": "Failed to load job",

  // ── Job Detail ─────────────────────────────────────────────────────────
  "Limpeza": "Cleaning",
  "Descrição": "Description",
  "Contato": "Contact",
  "Abrir no Google Maps": "Open in Google Maps",
  "Equipe:": "Team:",
  "Idioma falado pelo cliente": "Language spoken by the client",
  "Código da porta": "Door Code",
  "Observações importantes": "Important Notes",
  "Você precisa estar a até 200m do endereço para iniciar.": "You must be within 200m of the address to start.",
  "Iniciada em": "Started at",
  "FINALIZAR": "FINISH",
  "Reverter status para Agendada (admin)": "Revert status to Scheduled (admin)",
  "↩ Voltar para agendada (admin)": "↩ Revert to scheduled (admin)",
  "Finalizada em": "Finished at",
  "Duração": "Duration",
  "Limpeza encerrada": "Cleaning closed",
  "Baixar comprovante PDF": "Download PDF receipt",
  "Gerando comprovante…": "Generating receipt…",
  "Comprovante baixado": "Receipt downloaded",
  "Erro ao gerar PDF": "Error generating PDF",
  "AGENDADA": "SCHEDULED",
  "DESLOCAMENTO": "TRANSIT",
  "ANDAMENTO": "IN PROGRESS",
  "CANCELADA": "CANCELED",
  "📝 Checklist de limpeza": "📝 Cleaning Checklist",
  "concluídos": "completed",
  "Toque em um item para marcar como concluído. Será salvo ao finalizar a limpeza.":
    "Tap an item to mark it complete. It will be saved when you finish the cleaning.",
  "Fotos do serviço": "Service Photos",
  "Antes": "Before",
  "Depois": "After",
  "Assinatura do cliente": "Client Signature",
  "Assinatura capturada": "Signature captured",
  "Peça ao cliente para assinar abaixo (ou pule este passo — será salva automaticamente ao finalizar se houver desenho).":
    "Ask the client to sign below (or skip this step — it is saved automatically on finish if there is a drawing).",
  "Localização": "Location",
  "Contato do cliente": "Client Contact",
  "Resumo financeiro": "Financial Summary",
  "Valor da limpeza": "Cleaning Value",
  "Frequência": "Frequency",
  "Tipo": "Type",
  "membro(s)": "member(s)",
  "GPS indisponível": "GPS unavailable",
  "Limpeza iniciada": "Cleaning started",
  "Limpeza finalizada": "Cleaning finished",
  "↻ Próxima limpeza agendada automaticamente para {date}": "↻ Next cleaning automatically scheduled for {date}",
  "Voltar este atendimento para 'Agendada'? Os dados de START (hora e GPS) serão apagados.":
    "Revert this job to 'Scheduled'? START data (time and GPS) will be erased.",
  "Atendimento revertido para agendada": "Job reverted to scheduled",

  // ── Histórico ──────────────────────────────────────────────────────────
  "Meu trabalho": "My Work",
  "Histórico de limpezas": "Cleaning History",
  "Todas as casas que você já finalizou": "All the homes you've completed",
  "Buscar casa ou endereço": "Search home or address",
  "Casas atendidas": "Homes Served",
  "Tempo total": "Total Time",
  "Estimado a receber": "Estimated Earnings",
  "Nenhuma limpeza finalizada ainda.": "No finished cleanings yet.",
  "Data": "Date",
  "Início": "Start",
  "Fim": "End",
  "Valor": "Value",
  "Minhas limpezas": "My Cleanings",
  "Tudo o que você já finalizou": "Everything you've completed",

  // ── Agenda / Schedule ──────────────────────────────────────────────────
  "Janeiro": "January",
  "Fevereiro": "February",
  "Março": "March",
  "Abril": "April",
  "Maio": "May",
  "Junho": "June",
  "Julho": "July",
  "Agosto": "August",
  "Setembro": "September",
  "Outubro": "October",
  "Novembro": "November",
  "Dezembro": "December",
  "Dom": "Sun",
  "Seg": "Mon",
  "Ter": "Tue",
  "Qua": "Wed",
  "Qui": "Thu",
  "Sex": "Fri",
  "Sáb": "Sat",
  "Operação": "Operations",
  "Dia": "Day",
  "Semana": "Week",
  "Mês": "Month",
  "Agendar": "Book",
  "Buscar por cliente, equipe, colaborador…": "Search by client, team, collaborator…",
  "Crie pelo menos uma equipe antes de agendar": "Create at least one team before scheduling",
  "Agendado:": "Booked:",
  "Falha ao agendar": "Failed to schedule",
  "Movido para": "Moved to",
  "Falha ao mover": "Failed to move",
  "+{n} mais": "+{n} more",
  "Sem equipe": "No team",
  "atendimento(s)": "job(s)",
  "Sem limpezas.": "No cleanings.",
  "arraste para mover": "drag to move",
  "Selecione cliente e equipe": "Select a client and a team",
  "Informe a data e o horário do agendamento": "Enter the booking date and time",
  "Data/hora inválida": "Invalid date/time",
  "Informe um horário válido (00:00 não é permitido)": "Enter a valid time (00:00 is not allowed)",
  "Limpeza agendada": "Cleaning booked",
  "Agendar limpeza": "Book a Cleaning",
  "Data e Hora": "Date and Time",
  "Prioridade": "Priority",
  "Opcional — destaca no app do colaborador": "Optional — highlighted in the collaborator app",
  "— selecionar —": "— select —",
  "— Automática (por urgência) —": "— Automatic (by urgency) —",
  "🔴 Urgente": "🔴 Urgent",
  "🟢 Média": "🟢 Medium",
  "⚪ Baixa": "⚪ Low",
  "⚠️ Atenção: dia de folga": "⚠️ Warning: day off",
  "não trabalha": "doesn't work",
  "não trabalham": "don't work",
  "no dia escolhido. Você ainda pode agendar, mas confirme com a equipe antes.":
    "on the chosen day. You can still book it, but confirm with the team first.",
  "Cancelar": "Cancel",
  "Solicitações pendentes": "Pending Requests",
  "Nenhuma solicitação pendente. As novas aparecerão aqui.": "No pending requests. New ones will appear here.",
  "Arraste para o calendário para agendar": "Drag onto the calendar to schedule",
  "Sugerido:": "Suggested:",
  "Pré-agendar solicitação": "Pre-schedule Request",
  "Solicitado:": "Requested:",
  "Data alvo": "Target date",

  // ── Clientes ───────────────────────────────────────────────────────────
  "Carteira": "Portfolio",
  "Localizar por nome, e-mail, telefone, endereço…": "Search by name, email, phone, address…",
  "Ordenar clientes": "Sort clients",
  "A → Z (nome)": "A → Z (name)",
  "Z → A (nome)": "Z → A (name)",
  "Mais recentes (criação)": "Newest (created)",
  "Mais antigos (criação)": "Oldest (created)",
  "Maior valor": "Highest value",
  "Menor valor": "Lowest value",
  "Ver mapa": "View map",
  "Novo cliente": "New Client",
  "Novo Cliente": "New Client",
  "Editar Cliente": "Edit Client",
  "Nenhum cliente cadastrado ainda": "No clients registered yet",
  "Clique em": "Click",
  "para começar.": "to get started.",
  "Nenhum cliente encontrado": "No clients found",
  "Tente outros termos de busca ou": "Try other search terms or",
  "limpar filtro": "clear the filter",
  'Excluir cliente "{name}"?': 'Delete client "{name}"?',
  "Todas as limpezas relacionadas ainda serão preservadas no histórico, mas o cadastro do cliente será removido.":
    "All related cleanings will still be preserved in the history, but the client record will be removed.",
  "Excluir cliente": "Delete client",
  "Cliente excluído": "Client deleted",
  "Endereço incompleto:": "Incomplete address:",
  "sem rua": "no street",
  "sem CEP/ZIP": "no ZIP",
  "e": "and",
  "⚠ Endereço incompleto": "⚠ Incomplete address",
  "Visualizar cliente": "View client",
  "Excluir": "Delete",
  "Residencial": "Residential",
  "Comercial": "Commercial",
  "Condomínio": "Condominium",
  "Empresarial": "Corporate",
  "Avulsa": "One-time",
  "Semanal": "Weekly",
  "Quinzenal": "Biweekly",
  "Mensal": "Monthly",
  "Dados gerais": "General Info",
  "Cadastrar casa": "House Details",
  "Agendamento": "Scheduling",
  "Cliente salvo": "Client saved",
  "GPS recalculado": "GPS recalculated",
  "Nome Completo": "Full Name",
  "Nome Fantasia / Business Name": "Business Name",
  "Para clientes comerciais (opcional)": "For commercial clients (optional)",
  "Canais de Contato Disponíveis": "Available Contact Channels",
  "@ do Instagram": "Instagram handle",
  "Perfil do Facebook": "Facebook profile",
  "✓ Localização:": "✓ Location:",
  "Recalcular GPS deste cliente?": "Recalculate this client's GPS?",
  "Será usado o endereço atual (rua, cidade, estado, ZIP) para obter as coordenadas pelo OpenStreetMap.":
    "The current address (street, city, state, ZIP) will be used to fetch coordinates via OpenStreetMap.",
  "Recalcular": "Recalculate",
  "↻ Recalcular pelo endereço": "↻ Recalculate from address",
  "Preencha o endereço abaixo — o mapa aparece após salvar.": "Fill in the address below — the map appears after saving.",
  "Endereço (rua e número)": "Address (street and number)",
  "Nº do Apartamento": "Apartment #",
  "Código da Porta": "Door Code",
  "Tipo de Imóvel": "Property Type",
  "Valor da Limpeza (US$)": "Cleaning Value (US$)",
  "↻ Recorrência Automática": "↻ Automatic Recurrence",
  "Ao finalizar uma limpeza deste cliente, agendar automaticamente a próxima em":
    "When a cleaning for this client is finished, automatically schedule the next one in",
  "7 dias": "7 days",
  "14 dias": "14 days",
  "com a mesma equipe.": "with the same team.",
  "Data de início do contrato (MM/DD/YYYY)": "Contract start date (MM/DD/YYYY)",
  "Data final do contrato (MM/DD/YYYY) (opcional)": "Contract end date (MM/DD/YYYY) (optional)",
  "ⓘ Após {date}, a recorrência automática não criará mais novos atendimentos. Os já agendados continuam.":
    "ⓘ After {date}, automatic recurrence will no longer create new jobs. Already scheduled ones remain.",
  "Observações da Casa (destaque para equipe)": "House Notes (highlighted for the team)",
  "Ex: cuidado com pets, usar produto X, não limpar quarto trancado…":
    "E.g.: watch out for pets, use product X, don't clean the locked room…",
  "Idioma Falado pelo Cliente": "Language Spoken by the Client",
  "— não informado —": "— not informed —",
  "Checklist de Limpeza (itens padrão deste cliente)": "Cleaning Checklist (default items for this client)",
  "Fotos do Local": "Site Photos",
  "Salvar e agendar limpeza": "Save and book cleaning",
  "Adicionar à agenda": "Add to schedule",
  "Nome": "Name",
  "Adicionar": "Add",
  "Sugestões Rápidas:": "Quick Suggestions:",
  "Aspirar carpetes": "Vacuum carpets",
  "Limpar banheiros": "Clean bathrooms",
  "Trocar roupas de cama": "Change bed linens",
  "Lavar louça": "Wash dishes",
  "Limpar geladeira": "Clean fridge",
  "Tirar lixo": "Take out trash",
  "Limpar janelas": "Clean windows",
  "Passar pano no chão": "Mop floors",
  "Ex: Aspirar carpetes da sala": "E.g.: Vacuum living room carpets",
  "Subir": "Move up",
  "Descer": "Move down",
  "Remover": "Remove",

  // ── Equipes ────────────────────────────────────────────────────────────
  "Estrutura": "Structure",
  "Nova equipe": "New Team",
  'Excluir a equipe "{name}"?': 'Delete team "{name}"?',
  "Os equipamentos atribuídos voltarão para o estoque. Esta ação não pode ser desfeita.":
    "Assigned equipment will return to inventory. This action cannot be undone.",
  "Excluir equipe": "Delete team",
  "Equipe excluída": "Team deleted",
  "Considere renomear para algo memorável": "Consider renaming it to something memorable",
  "Renomear": "Rename",
  "✓ Dia concluído": "✓ Day complete",
  "Líder:": "Leader:",
  "Ver casas no mapa": "View homes on map",
  "Schedule semanal da equipe": "Team weekly schedule",
  "Editar equipe": "Edit Team",
  "Membros": "Members",
  "Casas atribuídas": "Assigned homes",
  "Mapa de casas —": "Homes map —",
  "de": "of",
  "casas com GPS capturado": "homes with GPS captured",
  "Nenhuma casa desta equipe tem GPS capturado. Edite os clientes e recapture o endereço pelo autocomplete.":
    "No home in this team has GPS captured. Edit the clients and recapture the address via autocomplete.",
  "Domingo": "Sunday",
  "Segunda": "Monday",
  "Terça": "Tuesday",
  "Quarta": "Wednesday",
  "Quinta": "Thursday",
  "Sexta": "Friday",
  "Sábado": "Saturday",
  "Schedule semanal —": "Weekly schedule —",
  "membros": "members",
  "Quem trabalha em cada dia da semana": "Who works on each day of the week",
  "Esta equipe ainda não tem membros atribuídos.": "This team has no members assigned yet.",
  "hoje": "today",
  "Folga": "Day off",
  "pessoa": "person",
  "pessoas": "people",
  "Equipe salva": "Team saved",
  "Nome da Equipe": "Team Name",
  "Cor da equipe": "Team color",
  "Azul": "Blue",
  "Verde": "Green",
  "Roxo": "Purple",
  "Rosa": "Pink",
  "Laranja": "Orange",
  "Vermelho": "Red",
  "Turquesa": "Teal",
  "Lima": "Lime",
  "Grafite": "Graphite",
  "Já usada por": "Already used by",
  "Cor selecionada:": "Selected color:",
  "· cores com ✕ já estão em uso por outra equipe": "· colors with ✕ are already in use by another team",
  "Líder": "Leader",
  "— escolher —": "— choose —",
  "Equipamentos da equipe": "Team equipment",
  "Quantidade ↔ disponível": "Quantity ↔ available",
  "Cadastre equipamentos no menu Equipamentos para distribuir.": "Register equipment in the Equipment menu to distribute.",
  "Disponível": "Available",
  "Salvar": "Save",
  "Cor": "Color",
  "Equipe renomeada": "Team renamed",
  "Falha ao renomear": "Failed to rename",
  "Clique para renomear": "Click to rename",

  // ── Colaboradores ──────────────────────────────────────────────────────
  "Time": "Team",
  "Mostrar inativos": "Show inactive",
  "Histórico de convites": "Invite History",
  "Convidar colaborador": "Invite Collaborator",
  "Novo colaborador": "New Collaborator",
  "Editar colaborador": "Edit Collaborator",
  "Colaborador reativado": "Collaborator reactivated",
  'Desativar colaborador "{name}"?': 'Deactivate collaborator "{name}"?',
  "O acesso ao sistema será removido e o colaborador não poderá mais ser atribuído a novas equipes ou limpezas. Os dados ficam guardados (pode reativar depois).":
    "System access will be removed and the collaborator can no longer be assigned to new teams or cleanings. Data is kept (you can reactivate later).",
  "Desativar": "Deactivate",
  "Colaborador desativado": "Collaborator deactivated",
  'Excluir permanentemente "{name}"?': 'Permanently delete "{name}"?',
  "Esta ação é DEFINITIVA. O colaborador será removido das equipes e apagado do banco de dados. As limpezas já realizadas continuam no histórico (com o nome em snapshot).":
    "This action is FINAL. The collaborator will be removed from teams and deleted from the database. Completed cleanings remain in the history (with a name snapshot).",
  "Excluir permanentemente": "Delete permanently",
  "{name} excluído permanentemente": "{name} permanently deleted",
  "Falha ao excluir": "Failed to delete",
  "1 colaborador(a) aguardando ativação": "1 collaborator awaiting activation",
  "{n} colaboradores aguardando ativação": "{n} collaborators awaiting activation",
  "e mais {n}": "and {n} more",
  "— defina cargo e dias de trabalho para ativar.": "— set position and workdays to activate.",
  "Ver agora": "View now",
  "Onboarding em andamento ({n})": "Onboarding in progress ({n})",
  "Continue de onde parou. Cada pessoa abaixo tem etapas faltando.":
    "Pick up where you left off. Each person below has missing steps.",
  "(sem nome)": "(no name)",
  "Falta": "Missing",
  "Cargo": "Position",
  "Dias": "Days",
  "Continuar": "Continue",
  "Localizar por nome, e-mail, telefone ou cargo…": "Search by name, email, phone or position…",
  "Ordenar colaboradores": "Sort collaborators",
  "Por cargo": "By position",
  "Por função (admin/colaborador)": "By role (admin/collaborator)",
  "Nenhum colaborador encontrado para": "No collaborators found for",
  "Defina cargo/equipe e reative para liberar o acesso": "Set position/team and reactivate to grant access",
  "⚠ Aguardando ativação": "⚠ Awaiting activation",
  "ativo": "active",
  "inativo": "inactive",
  "Reativar": "Reactivate",
  "Visualizar": "View",
  "Desativar (soft delete)": "Deactivate (soft delete)",
  "Valor por dia": "Daily rate",
  "não informado": "not provided",
  "📅 Dias de trabalho": "📅 Workdays",
  "Todos os dias": "Every day",
  "Cargo:": "Position:",
  "Fechar": "Close",
  "Colaborador salvo": "Collaborator saved",
  "Dados": "Info",
  "Cargo + dias": "Position + days",
  "Para ativar esta pessoa, complete as etapas acima — defina cargo e dias de trabalho destacados em amarelo abaixo, escolha uma equipe, agende a primeira semana e clique em Salvar.":
    "To activate this person, complete the steps above — set the position and workdays highlighted in yellow below, choose a team, schedule the first week and click Save.",
  "Alterar o e-mail também muda o login do colaborador.": "Changing the email also changes the collaborator's login.",
  "Senha (deixe vazio para manter)": "Password (leave empty to keep)",
  "Cargo / Função": "Position / Role",
  "— selecione —": "— select —",
  "Colaborador(a)": "Collaborator",
  "Ativo": "Active",
  "Inativo": "Inactive",
  "Valor por dia (US$)": "Daily rate (US$)",
  "@usuario, telefone ou e-mail": "@user, phone or email",
  "Dias de trabalho na semana": "Workdays of the week",
  "Foto": "Photo",
  "Cargo de acesso": "Access role",
  "adicionado à equipe": "added to team",
  "Falha ao adicionar à equipe": "Failed to add to team",
  "Nenhuma limpeza nova para gerar (todas já agendadas ou equipe sem clientes).":
    "No new cleanings to generate (all already scheduled or team has no clients).",
  "{n} limpeza(s) agendada(s) para os próximos 7 dias": "{n} cleaning(s) booked for the next 7 days",
  "Falha ao gerar escala": "Failed to generate schedule",
  "Adicionado(a) à equipe": "Added to team",
  "{n} limpeza(s) agendada(s) nos próximos 7 dias para {team}.": "{n} cleaning(s) booked in the next 7 days for {team}.",
  "Nenhuma limpeza nova para gerar (já cobertas ou equipe sem clientes).":
    "No new cleanings to generate (already covered or team has no clients).",
  "Avisar pelo WhatsApp": "Notify via WhatsApp",
  "Quer já agendar a primeira semana de limpezas com base nos dias de trabalho dele(a)?":
    "Want to schedule the first week of cleanings based on their workdays?",
  "Agendando…": "Booking…",
  "Agendar semana": "Book week",
  "Pular — agendar depois": "Skip — schedule later",
  "Sugestão: adicionar à equipe": "Suggestion: add to team",
  "Equipe sem membros ainda — boa para começar.": "Team with no members yet — good to start.",
  "{n} membro(s) atualmente — equipe com mais capacidade.": "{n} member(s) currently — team with more capacity.",
  "Outras opções:": "Other options:",
  "Pular esta etapa — configurar depois": "Skip this step — set up later",
  "Adicionando…": "Adding…",
  "📅 Schedule semanal da equipe": "📅 Team Weekly Schedule",
  "colaboradores ativos": "active collaborators",
  "Próxima semana": "Next week",
  "Ninguém": "Nobody",
  "jan": "Jan", "fev": "Feb", "mar": "Mar", "abr": "Apr", "mai": "May", "jun": "Jun",
  "jul": "Jul", "ago": "Aug", "set": "Sep", "out": "Oct", "nov": "Nov", "dez": "Dec",
  "agora": "now",
  "{n}h atrás": "{n}h ago",
  "{n}d atrás": "{n}d ago",
  "convite aguardando aprovação": "invitation awaiting approval",
  "convites aguardando aprovação": "invitations awaiting approval",
  "Colaboradores que enviaram seus dados via link de convite.": "Collaborators who submitted their info via invite link.",
  "Sem nome": "No name",
  "Revisar e aprovar": "Review and approve",
  "Rejeitar este convite?": "Reject this invitation?",
  "Convite rejeitado": "Invitation rejected",
  "Revisar dados do colaborador": "Review Collaborator Info",
  "Confira os dados enviados. Após aprovar, o colaborador será criado como inativo — defina o cargo e a equipe antes de ativar o acesso.":
    "Review the submitted info. After approval, the collaborator is created as inactive — set the position and team before activating access.",
  "Convite aprovado! Defina cargo e dias de trabalho abaixo.": "Invitation approved! Set position and workdays below.",
  "Falha ao aprovar": "Failed to approve",
  "Aprovando…": "Approving…",
  "Aprovar e criar colaborador": "Approve and create collaborator",
  "Para qual colaborador é este convite? O nome ajuda você a identificar no histórico.":
    "Who is this invitation for? The name helps you identify it in the history.",
  "Nome do colaborador (opcional)": "Collaborator name (optional)",
  "Ex.: João Silva": "E.g.: John Smith",
  "Gerando convite…": "Generating invite…",
  "Gerar convite": "Generate invite",
  "Falha ao gerar convite": "Failed to generate invite",
  "copiado": "copied",
  "Código": "Code",
  "Convite para": "Invitation for",
  "Envie o link ou código abaixo. Validade:": "Send the link or code below. Valid for:",
  "Envie este link ou código para o colaborador. Ele preenche os dados sozinho e você aprova depois. Validade:":
    "Send this link or code to the collaborator. They fill in their info and you approve it later. Valid for:",
  "Link do convite": "Invite link",
  "Código curto": "Short code",
  "Todos": "All",
  "Pendentes": "Pending",
  "Aguardando": "Waiting",
  "Aprovados": "Approved",
  "Rejeitados": "Rejected",
  "Expirados": "Expired",
  "Revogados": "Revoked",
  "Aguardando preenchimento": "Awaiting completion",
  "Aguardando aprovação": "Awaiting approval",
  "Aprovado": "Approved",
  "Rejeitado": "Rejected",
  "Expirado": "Expired",
  "Revogado": "Revoked",
  "Revogar este convite? O link deixará de funcionar.": "Revoke this invitation? The link will stop working.",
  "Convite revogado": "Invitation revoked",
  "Link copiado": "Link copied",
  "Nenhum convite": "No invitations",
  "com status": "with status",
  "(sem nome cadastrado)": "(no name registered)",
  "Criado:": "Created:",
  "Preenchido:": "Submitted:",
  "Expira:": "Expires:",
  "Copiar link": "Copy link",
  "Revogar": "Revoke",

  // ── Financeiro ─────────────────────────────────────────────────────────
  "Pagamentos & Faturamento": "Payments & Billing",
  "📊 Ver Relatórios Detalhados (Equipe/Colaborador/Cliente + PDF) →": "📊 View Detailed Reports (Team/Collaborator/Client + PDF) →",
  "De": "From",
  "Até": "To",
  "A pagar (folha)": "Payroll due",
  "Produtos / Despesas": "Products / Expenses",
  "Lucro estimado": "Estimated profit",
  "Limpezas finalizadas": "Finished cleanings",
  "Produtos & compras": "Products & Purchases",
  "Kits de compra": "Shopping kits",
  "Nova compra": "New purchase",
  "Nenhuma compra registrada no período.": "No purchases recorded in the period.",
  "Excluir esta compra/despesa?": "Delete this purchase/expense?",
  "Despesa excluída": "Expense deleted",
  "produto": "product",
  "equipamento": "equipment",
  "uniforme": "uniform",
  "outro": "other",
  "Produto / Item": "Product / Item",
  "Categoria": "Category",
  "Fornecedor": "Supplier",
  "Qtd": "Qty",
  "Preço unit.": "Unit price",
  "Pagamentos a colaboradores": "Collaborator payments",
  "Nenhum pagamento no período.": "No payments in the period.",
  "Casas": "Homes",
  "Valor / dia": "Rate / day",
  "Editar compra": "Edit purchase",
  "Nova compra / produto": "New purchase / product",
  "Despesa registrada": "Expense saved",
  "Ex: Detergente, Pano de microfibra…": "E.g.: Detergent, microfiber cloth…",
  "Produto de limpeza": "Cleaning product",
  "Equipamento": "Equipment",
  "Uniforme / EPI": "Uniform / PPE",
  "Outro": "Other",
  "Ex: Walmart, Costco, Home Depot…": "E.g.: Walmart, Costco, Home Depot…",
  "Quantidade": "Quantity",
  "Preço Unitário (US$)": "Unit Price (US$)",
  "Total da compra": "Purchase total",

  // ── Recebimentos ───────────────────────────────────────────────────────
  "Em atraso": "Overdue",
  "Vence em breve": "Due soon",
  "Em dia": "On time",
  "Acompanhe pagamentos previstos por cliente. Quem está em atraso, quem vai vencer e quem está em dia.":
    "Track expected payments per client. Who is overdue, who is due soon and who is on time.",
  "Valor em atraso": "Overdue amount",
  "Buscar cliente ou endereço…": "Search client or address…",
  "Nenhum cliente nesse filtro.": "No clients in this filter.",
  "Para registrar cobranças, defina o": "To track billing, set the",
  "dia de pagamento": "payment day",
  "valor": "value",
  "em cada cliente.": "on each client.",
  "Ir para clientes →": "Go to clients →",
  "Vencimento": "Due date",
  "dia atrás": "day ago",
  "dias atrás": "days ago",
  "Registrar": "Record",
  "Lembrete de pagamento": "Payment reminder",
  "Pagamento registrado": "Payment recorded",
  "Registrar pagamento —": "Record payment —",
  "Valor recebido": "Amount received",
  "Referente ao vencimento de": "For the due date of",
  "Método": "Method",
  "Dinheiro": "Cash",
  "Cheque": "Check",
  "Salvando…": "Saving…",
  "Falha ao gerar link": "Failed to generate link",
  "Não foi possível copiar": "Could not copy",
  "Cobrar": "Charge",
  "Gerar link de pagamento": "Generate payment link",
  "via Stripe Checkout (cartão de crédito).": "via Stripe Checkout (credit card).",
  "Valor a cobrar (USD)": "Amount to charge (USD)",
  "Gerar link": "Generate link",
  "Link gerado": "Link generated",
  "Copiar": "Copy",
  "O pagamento é registrado automaticamente quando o cliente concluir.":
    "The payment is recorded automatically when the client completes it.",

  // ── Signup / Recuperação ───────────────────────────────────────────────
  "A senha precisa ter ao menos 6 caracteres": "Password must be at least 6 characters",
  "As senhas não coincidem": "Passwords don't match",
  'Empresa "{name}" criada! Você tem 14 dias de trial.': 'Company "{name}" created! You have a 14-day trial.',
  "Falha ao criar empresa": "Failed to create company",
  "14 dias grátis · sem cartão": "14 days free · no card required",
  "A operação da sua empresa de limpeza,": "Your cleaning company's operations,",
  "no piloto automático": "on autopilot",
  "Agende equipes, valide geolocalização, mande recibos no WhatsApp e controle financeiro — tudo em um só lugar.":
    "Schedule teams, validate geolocation, send receipts on WhatsApp and track finances — all in one place.",
  "Seus dados, isolados": "Your data, isolated",
  "Cada empresa só vê seus próprios clientes, colaboradores e finanças.":
    "Each company only sees its own clients, collaborators and finances.",
  "Pronto em 30 segundos": "Ready in 30 seconds",
  "Crie sua conta, convide seu primeiro colaborador e comece a agendar.":
    "Create your account, invite your first collaborator and start scheduling.",
  "Personalize logo, cores e dados da empresa para recibos e PDFs.":
    "Customize logo, colors and company info for receipts and PDFs.",
  "Criar minha empresa": "Create my company",
  "Em menos de 1 minuto você está agendando a primeira limpeza.": "In less than 1 minute you'll be booking your first cleaning.",
  "Nome da empresa": "Company name",
  "Ex.: Clean Manager USA": "E.g.: Clean Manager USA",
  "Seu nome": "Your name",
  "Ex.: Maria Silva": "E.g.: Mary Smith",
  "E-mail (será seu login)": "Email (your login)",
  "Telefone (opcional)": "Phone (optional)",
  "Mínimo 6 caracteres": "Minimum 6 characters",
  "Confirmar senha": "Confirm password",
  "Digite novamente": "Type it again",
  "Criando empresa…": "Creating company…",
  "Criar empresa com Google": "Create company with Google",
  "Já tem conta?": "Already have an account?",
  "Recuperar senha": "Recover Password",
  "Se este e-mail existir, geramos um link de recuperação (verifique os logs do servidor em ambiente de teste).":
    "If this email exists, we generated a recovery link (check your inbox).",
  "Enviar link": "Send link",
  "Voltar ao login": "Back to login",
  "Definir nova senha": "Set New Password",
  "Senha alterada": "Password changed",
  "Nova Senha": "New Password",
  "Alterar senha": "Change password",

  // ── Perfil ─────────────────────────────────────────────────────────────
  "Minha conta": "My Account",
  "Perfil": "Profile",
  "Foto de reconhecimento": "ID Photo",
  "Usada nos crachás, mapas e relatórios. Mesma foto que os colaboradores usam.":
    "Used on badges, maps and reports. Same photo collaborators use.",
  "Dados pessoais": "Personal Info",
  "Nome completo": "Full Name",
  "Telefone (US)": "Phone (US)",
  "(criptografado · só você vê)": "(encrypted · only you can see)",
  "ocultar": "hide",
  "mostrar": "show",
  "Endereço": "Address",
  "Rua e número": "Street and Number",
  "Apto / Suite": "Apt / Suite",
  "Cidade": "City",
  "Estado": "State",
  "Dados da empresa": "Company Info",
  "Informações que aparecem nos invoices, recibos e PDFs.": "Information shown on invoices, receipts and PDFs.",
  "Razão social": "Legal Name",
  "Telefone": "Phone",
  "Login com Google": "Google Sign-In",
  "Trocar senha (opcional)": "Change Password (optional)",
  "Senha atual": "Current Password",
  "Nova senha": "New Password",
  "Salvar alterações": "Save Changes",
  "Informe a senha atual para trocar": "Enter your current password to change it",
  "Perfil atualizado": "Profile updated",
  "Redes sociais": "Social Media",
  "Marque as redes que você usa — os campos aparecem conforme você seleciona.":
    "Select the networks you use — fields appear as you select.",
  "Selecione acima as redes que você usa.": "Select the networks you use above.",
  "Conta conectada com Google": "Account connected with Google",
  "Você pode entrar usando o botão 'Entrar com Google' na tela de login.":
    "You can sign in using the 'Sign in with Google' button on the login screen.",
  "Conecte seu Google para entrar com 1 clique (mesmo e-mail).": "Connect your Google to sign in with 1 click (same email).",
  "Desconectar": "Disconnect",
  "Conectar com Google": "Connect with Google",
  "Conta Google desconectada": "Google account disconnected",
  "Idioma do sistema": "System Language",
  "Escolha o idioma da interface. A preferência fica salva no seu perfil.":
    "Choose the interface language. Your preference is saved to your profile.",
  "Idioma atualizado": "Language updated",

  // ── Hoje / TodayOverview (i18n Phase 3) ────────────────────────────────
  "Operações": "Operations",
  "Atualiza automaticamente a cada 30s.": "Auto-refreshes every 30s.",
  "Carregando dados…": "Loading data…",
  "Concluídas": "Completed",
  "Próximas": "Upcoming",
  "Faturamento": "Revenue",
  "previsto": "expected",
  "Progresso do dia": "Daily progress",
  "Mapa ao vivo": "Live Map",
  "equipe(s) em campo": "team(s) in the field",
  "Próximas limpezas": "Upcoming cleanings",
  "Nenhuma limpeza agendada nas próximas horas.": "No cleanings scheduled in the next hours.",
  "Endereço não informado": "Address not provided",
  "equipes sem job ativo ou agendado nas próximas 2h": "teams with no active or scheduled job in the next 2 hours",
  "equipe sem job ativo ou agendado nas próximas 2h": "team with no active or scheduled job in the next 2 hours",
  "Considere distribuir uma limpeza não agendada ou liberar o time.": "Consider assigning a pending cleaning or freeing the team.",
  "Limpezas sem equipe": "Cleanings without a team",
  "Aloque uma equipe antes do horário": "Assign a team before the scheduled time",
  "Atrasadas (não iniciaram)": "Overdue (not started)",
  "Ligue para o colaborador e confirme se vai começar": "Call the collaborator to confirm",
  "Faturas vencidas": "Overdue invoices",
  "Envie cobrança ou link de pagamento": "Send a reminder or payment link",
  "vence": "due",
  "Agendamentos pendentes": "Pending bookings",
  "Cliente pediu via portal — aprove ou recuse": "Client requested via portal — approve or decline",
  "alertas requerem sua atenção": "alerts need your attention",
  "alerta requer sua atenção": "alert needs your attention",
  "Ver tudo →": "View all →",
  "outros": "others",

  // ── Liberação manual por dia ───────────────────────────────────────────
  "Aguardando liberação da agenda de hoje": "Waiting for today's schedule release",
  "Assim que o administrador liberar, suas casas aparecem aqui automaticamente.":
    "As soon as the admin releases it, your houses will appear here automatically.",

  // ── Schedule modal (Edit/Delete) ───────────────────────────────────────
  "Cliente removido": "Client removed",
  "Equipe removida": "Team removed",
  "Excluir definitivamente?": "Permanently delete?",
  "Apenas esta ocorrência é apagada do banco. As demais permanecem.":
    "Only this occurrence is deleted from the database. Others remain.",
  "Atendimento excluído": "Cleaning deleted",
  "Limpar agendamentos órfãos?": "Clean up orphan cleanings?",
  "Esta ação apaga todos os agendamentos cujo cliente OU equipe não existe mais no sistema. Útil quando você apagou um cliente/equipe e ficaram limpezas fantasmas na agenda. Não pode ser desfeito.":
    "This deletes all cleanings whose client OR team no longer exists. Useful when you deleted a client/team and ghost cleanings were left behind. Cannot be undone.",
  "Limpar todos": "Clean up all",
  "agendamento(s) órfão(s)": "orphan cleaning(s)",
  "agendamento(s) órfão(s) removido(s)": "orphan cleaning(s) removed",
  "cliente ou equipe foi apagado mas os agendamentos ficaram na agenda.":
    "client or team was deleted but the cleanings stayed on the schedule.",
  "Falha ao limpar": "Failed to clean up",

  // ── Recebimentos (Edit/Delete) ─────────────────────────────────────────
  "Excluir cobrança recorrente?": "Remove recurring billing?",
  "Esta ação removerá a configuração de cobrança (dia de vencimento e valor) do cliente {name}. Ele deixará de aparecer nesta lista. As limpezas e pagamentos já registrados serão mantidos.":
    "This will remove the billing setup (due day and amount) for {name}. They will no longer appear on this list. Existing cleanings and payments are kept.",
  "Cobrança removida": "Billing removed",

  // ── Reports (i18n Phase 3) ─────────────────────────────────────────────
  "Análises": "Analytics",
  "Limpezas no período": "Cleanings in period",
  "Tempo médio": "Average time",
  "Limpezas por dia": "Cleanings per day",
  "Produtividade por equipe": "Team productivity",
  "(colab.)": "(collab.)",

  // ── Positions (Cargos) ─────────────────────────────────────────────────
  "Cargos & Funções": "Positions & Roles",
  "Cadastre os cargos usados ao registrar colaboradores": "Set up the positions used when registering collaborators",
  "Novo cargo": "New position",
  "Excluir cargo": "Delete position",
  "Cargo excluído": "Position deleted",
  "Editar cargo": "Edit position",
  "Cargo salvo": "Position saved",
  "Valor padrão / dia": "Default per-day value",
  "Nenhum cargo cadastrado.": "No positions registered yet.",
  "Nome do Cargo": "Position name",
  "Ex: Faxineira, Líder de equipe…": "E.g., Cleaner, Team Leader…",
  "O que esse cargo faz na operação": "What this position does in the operation",
  "Valor Padrão por Dia (US$)": "Default value per day (US$)",

  // ── Equipments ─────────────────────────────────────────────────────────
  "Cadastre os equipamentos e a quantidade total disponível": "Register equipment and total quantity available",
  "Novo equipamento": "New equipment",
  "Equipamento excluído": "Equipment deleted",
  "Esta ação não pode ser desfeita.": "This action cannot be undone.",

  // ── Supplies ───────────────────────────────────────────────────────────
  "Cadastre os consumíveis (produtos, químicos, descartáveis, EPI) e controle o estoque":
    "Register consumables (products, chemicals, disposables, PPE) and manage stock",
  "Lista de reposição": "Restock list",
  "Novo item": "New item",
  "Item excluído": "Item deleted",
  "Todo o histórico de movimentações deste item será apagado também. Esta ação não pode ser desfeita.":
    "All movement history for this item will also be deleted. This action cannot be undone.",
  "item(ns) abaixo ou no estoque mínimo.": "item(s) at or below minimum stock.",

  // ── MyHistory ──────────────────────────────────────────────────────────

  // ── Notifications (List + Settings + History) ──────────────────────────
  "Notificações ao cliente": "Client notifications",
  "sem ler": "unread",
  "Eventos do sistema: agendamentos, check-ins, pagamentos, limpezas finalizadas e alertas.":
    "System events: bookings, check-ins, payments, finished cleanings and alerts.",
  "Todas": "All",
  "Sem ler": "Unread",
  "Marcar todas como lidas": "Mark all as read",
  "Anteriores": "Earlier",
  "Nova solicitação": "New booking request",
  "Check-in colaborador": "Collaborator check-in",
  "Pagamento": "Payment",
  "Alerta": "Alert",
  "Notificação": "Notification",
  "Novo": "New",
  "Ver →": "View →",
  "Marcar lido": "Mark read",
  "Tudo em dia! Nenhuma notificação não lida.": "All caught up! No unread notifications.",
  "Sua caixa de entrada está vazia": "Your inbox is empty",
  "Aqui aparecem os eventos do sistema: novos agendamentos, check-ins, pagamentos recebidos, limpezas finalizadas e alertas operacionais.":
    "System events show up here: new bookings, check-ins, payments received, finished cleanings and operational alerts.",

  // NotificationSettings
  "Erro ao carregar configurações": "Failed to load settings",
  "Configurações salvas": "Settings saved",
  "Erro ao salvar": "Failed to save",
  "Disparada quando um cliente é cadastrado ou uma nova limpeza é agendada.":
    "Triggered when a client is registered or a new cleaning is scheduled.",
  "Disparada 1 dia antes da limpeza agendada como lembrete.":
    "Triggered 1 day before the scheduled cleaning as a reminder.",
  "Disparada quando o colaborador clica em \"START\" no app mobile.":
    "Triggered when the collaborator taps \"START\" in the mobile app.",
  "Disparada quando a limpeza é finalizada (envia também o PDF do comprovante quando disponível).":
    "Triggered when the cleaning is finished (also sends the receipt PDF when available).",
  "Nome do cliente": "Client name",
  "Data da limpeza (MM/DD/AAAA)": "Cleaning date (MM/DD/YYYY)",
  "Horário da limpeza (ex: 10:00 AM)": "Cleaning time (e.g., 10:00 AM)",
  "Nome da equipe responsável": "Team name in charge",
  "Configure templates de mensagem para WhatsApp/SMS. As mensagens são enviadas via link direto wa.me/sms — você confirma o envio com 1 clique no app do WhatsApp.":
    "Set up message templates for WhatsApp/SMS. Messages are sent via wa.me/sms deep link — you confirm with 1 tap in your WhatsApp app.",
  "Salvar configurações": "Save settings",
  "Variáveis disponíveis nos templates:": "Variables available in templates:",
  "Template da mensagem": "Message template",
  "Digite a mensagem...": "Type the message...",
  "Preview": "Preview",
  "Como usar:": "How to use:",
  "Após salvar, vá em uma limpeza, clique no botão": "After saving, open a cleaning and tap the",
  "Notificar cliente": "Notify client",
  "e o WhatsApp/SMS abrirá com a mensagem do template já preenchida com os dados do cliente. Basta clicar enviar.":
    "button — WhatsApp/SMS will open with the template message already filled with the client's data. Just tap send.",

  // NotificationHistory
  "Histórico de notificações": "Notification history",
  "Registro de mensagens enviadas (manual via WhatsApp/SMS) e lembretes automáticos pendentes (gerados pelo cron a cada 30 min).":
    "Log of messages sent (manual via WhatsApp/SMS) and pending automatic reminders (generated by cron every 30 min).",
  "Apagar tudo": "Delete all",
  "Período:": "Period:",
  "Última semana": "Last week",
  "Este mês": "This month",
  "Este ano": "This year",
  "registro": "record",
  "registros": "records",
  "Tipo:": "Type:",
  "Confirmação": "Confirmation",
  "Lembrete": "Reminder",
  "Equipe chegou": "Team arrived",
  "Concluída": "Finished",
  "Recibo de pagamento": "Payment receipt",
  "Invoice": "Invoice",
  "Invoice (Fatura)": "Invoice",
  "WhatsApp": "WhatsApp",
  "SMS": "SMS",
  "Cron (pendente)": "Cron (pending)",
  "Destinatário": "Recipient",
  "Canal": "Channel",
  "Enviado por": "Sent by",
  "Mensagem": "Message",
  "Nenhuma notificação enviada ainda.": "No notifications sent yet.",
  "Nenhum registro neste tipo. Tente outro filtro.": "No records of this type. Try another filter.",
  "Excluir notificação": "Delete notification",
  "Digite sua senha de admin para confirmar a exclusão.": "Enter your admin password to confirm deletion.",
  "Senha do admin": "Admin password",
  "Confirmar exclusão": "Confirm deletion",
  "Apagar TODO o histórico": "Delete ALL history",
  "Esta ação é irreversível. Todos os {count} registros serão removidos. Digite sua senha de admin para confirmar.":
    "This action is irreversible. All {count} records will be removed. Enter your admin password to confirm.",
  "Notificação excluída": "Notification deleted",
  "notificações apagadas": "notifications deleted",
  "Erro": "Error",

  // FinanceReports
  "Por Equipe": "By Team",
  "Por Colaborador": "By Collaborator",
  "Por Cliente": "By Client",
  "início": "start",
  "Custom": "Custom",
  "Limpezas": "Cleanings",
  "A pagar (colaboradores)": "To pay (collaborators)",
  "Imprimir PDF": "Print PDF",
  "Sem limpezas finalizadas no período.": "No finished cleanings in this period.",
  "Faturado": "Invoiced",
  "Invoice gerado": "Invoice generated",
  "Erro ao gerar invoice": "Error generating invoice",
  "Baixar invoice em PDF": "Download invoice as PDF",
  "Invoice PDF": "Invoice PDF",
  "Nenhum cliente com limpezas finalizadas.": "No clients with finished cleanings.",
  "limpeza": "cleaning",
  "limpezas": "cleanings",
  "Total pago": "Total paid",

  // ── i18n Fase 4 ────────────────────────────────────────────────────────
  // StatusColors
  "Personalização": "Customization",
  "Cores das atividades": "Activity Colors",
  "Personalize as cores que aparecem na agenda, dashboard e cards conforme o status da limpeza": "Customize the colors shown in the schedule, dashboard and cards according to the cleaning status",
  "Escolha a cor": "Choose the color",
  "Cor personalizada": "Custom color",
  "Descrição (opcional)": "Description (optional)",
  "Salvando...": "Saving...",
  'Cor de "{label}" salva': 'Color for "{label}" saved',
  // BookingRequests
  "Aprovadas": "Approved",
  "Agendadas": "Scheduled",
  "Recusadas": "Rejected",
  "Em análise": "Under review",
  "Aprovada": "Approved",
  "Recusada": "Rejected",
  "Solicitações de Agendamento": "Booking Requests",
  "Pedidos enviados pelos clientes via portal.": "Requests sent by clients via the portal.",
  "Limpar testes": "Clear test data",
  "Nenhuma solicitação encontrada.": "No requests found.",
  "Data preferida": "Preferred date",
  "Enviado em": "Sent on",
  "Sua resposta:": "Your response:",
  "Aprovar": "Approve",
  "Marcar como Agendada": "Mark as Scheduled",
  "Recusar": "Reject",
  "Solicitação atualizada": "Request updated",
  "Solicitação excluída": "Request deleted",
  "Excluir solicitação?": "Delete request?",
  "Motivo da recusa (opcional, será mostrado ao cliente):": "Reason for rejection (optional, will be shown to the client):",
  "Nenhuma solicitação de teste encontrada": "No test requests found",
  "Excluir testes": "Delete test data",
  // JobDetail
  "Notas do cliente (todas as visitas)": "Client notes (all visits)",
  // Agendamento (ScheduleOnboardingForm)
  "Atualizar agenda": "Update schedule",
  "Rotina ativa": "Active routine",
  "Este cliente tem uma rotina de limpeza configurada": "This client has a recurring cleaning routine set up",
  "Filtrar por rotina": "Filter by routine",
  "Todas as rotinas": "All clients",
  "Com rotina ativa": "With active routine",
  "Sem rotina": "Without routine",
  "{without} de {total} clientes ainda sem rotina": "{without} of {total} clients still without a routine",
  "Mostrando só os sem rotina — clique para ver todos.": "Showing only clients without a routine — click to see all.",
  "Configure uma agenda recorrente e transforme em receita previsível. Clique para filtrar.": "Set up a recurring schedule and turn it into predictable revenue. Click to filter.",
  "{count} de {total} clientes sem rotina recorrente": "{count} of {total} clients without a recurring routine",
  "Configure agendas recorrentes e transforme em receita previsível.": "Set up recurring schedules and turn them into predictable revenue.",
  "Configurar →": "Set up →",
  "Marcar dia como concluído": "Mark day as completed",
  "Dia concluído — {n} casa(s) marcadas como feitas": "Day completed — {n} house(s) marked as done",
  "Falha ao concluir o dia": "Failed to complete the day",
  "Dia fechado por {name}": "Day closed by {name}",
  "casa(s)": "house(s)",
  "Progresso do dia por equipe": "Today's progress by team",
  "em campo": "in field",
  "pendentes": "pending",
  "Filtrar por equipe": "Filter by team",
  "Todas as equipes": "All teams",
  "Colaborador salvo · senha atualizada": "Collaborator saved · password updated",
  "O campo fica em branco por segurança. Digite uma nova senha para trocar; deixe vazio para manter a atual.": "This field stays blank for security. Type a new password to change it; leave empty to keep the current one.",
  "Senha forte gerada e copiada": "Strong password generated and copied",
  "Gerar senha forte": "Generate strong password",
  "Gerar": "Generate",
  "Copiar senha": "Copy password",
  "Senha copiada": "Password copied",
  "Digite ou gere uma senha primeiro": "Type or generate a password first",
  "Editar orçamento": "Edit estimate",
  "Novo orçamento": "New estimate",
  "Preparado por": "Prepared by",
  "Orçamento para": "Estimate for",
  "Pets": "Pets",
  "Nome do(s) Pet(s)": "Pet name(s)",
  "Tipo de imóvel": "Property type",
  "Especifique o tipo…": "Specify the type…",
  "Nº de Quartos": "No. of Bedrooms",
  "Nº de Banheiros": "No. of Bathrooms",
  "Metragem (sqft)": "Square footage (sqft)",
  "Cômodos a serem limpos": "Rooms to be cleaned",
  "Outros cômodos…": "Other rooms…",
  "Tipo de limpeza": "Cleaning type",
  "Especifique…": "Specify…",
  "Dias preferidos": "Preferred days",
  "Horário preferido": "Preferred time",
  "Você fornecerá os produtos de limpeza?": "Will you provide the cleaning products?",
  "Serviços adicionais": "Additional services",
  "Tarifas (US$)": "Rates (US$)",
  "Por limpeza semanal": "Per weekly cleaning",
  "Por limpeza quinzenal": "Per bi-weekly cleaning",
  "Por limpeza mensal": "Per monthly cleaning",
  "Por outra frequência": "Per other frequency",
  "Instruções da chave / acesso": "Key / access instructions",
  "Código da porta, alarme, onde deixar a chave…": "Door code, alarm, where to leave the key…",
  "Situação do orçamento": "Estimate status",
  "Enviar para cadastro de cliente": "Send to client registration",
  "Criar cliente já preenchido com os dados deste orçamento": "Create a client pre-filled with this estimate's data",
  "Salvar orçamento": "Save estimate",
  "Nome é obrigatório": "Name is required",
  "Orçamento atualizado": "Estimate updated",
  "Orçamento criado": "Estimate created",
  "Preencha o nome antes de enviar para o cadastro de cliente": "Fill in the name before sending to client registration",
  "Dados enviados para o cadastro de cliente": "Data sent to client registration",
  "Crie e gerencie invoices/orçamentos para clientes.": "Create and manage invoices/estimates for clients.",
  "Status": "Status",
  "Ações": "Actions",
  "Rejeitar": "Reject",
  "Reabrir": "Reopen",
  "Baixar PDF": "Download PDF",
  "Criar cliente": "Create client",
  "Marcar como aprovado": "Mark as approved",
  "Marcar como rejeitado": "Mark as rejected",
  "Criar cliente com dados deste orçamento": "Create client with this estimate's data",
  "PDF gerado": "PDF generated",
  "Excluir orçamento de \"{name}\"?": "Delete estimate for \"{name}\"?",
  "Orçamento excluído": "Estimate deleted",
  "Status atualizado": "Status updated",
  "Em aberto": "Open",
  "Casa única": "Single family",
  "Sobrado": "Townhouse",
  "Apartamento": "Apartment",
  "Cozinha": "Kitchen",
  "Sala de família": "Family room",
  "Sala de estar": "Living room",
  "Sala de jantar": "Dining room",
  "Escadas": "Stairways",
  "Sótão": "Attic",
  "Porão": "Basement",
  "Garagem": "Garage",
  "Lavanderia": "Utility room",
  "Escritório": "Office / Den",
  "Sala de recreação": "Rec room",
  "Corredor": "Hallway",
  "Padrão": "Standard",
  "Profunda": "Deep",
  "Festa / Ocasião especial": "Party / Special occasion",
  "Janelas": "Windows",
  "Mudança (entrada/saída)": "Move in/out",
  "Única vez": "One time",
  "2x por mês": "Twice a month",
  "Sazonal": "Seasonally",
  "Anual": "Annually",
  "8h – 11h": "8am – 11am",
  "11h – 16h": "11am – 4pm",
  "16h – 19h": "4pm – 7pm",
  "Limpeza de forno": "Oven cleaning",
  "Geladeira": "Refrigerator",
  "Lavagem de paredes": "Wall washing",
  "Persianas": "Mini blinds",
  "Luminárias": "Light fixtures",
  "Encerar piso": "Floor waxing",
  "Sim": "Yes",
  "Não": "No",
  "SMS (Texto)": "SMS (Text)",
  "Sem link público": "No public link",
  "Cliente sem telefone cadastrado": "Client has no phone on file",
  "Cliente sem e-mail cadastrado": "Client has no email on file",
  "Nenhum link disponível para este registro": "No link available for this record",
  "Link copiado!": "Link copied!",
  "Enviar": "Send",
  "João da Silva": "John Doe",
  "123 Main St, Cidade, Estado 00000": "123 Main St, City, State 00000",
  "Nenhum orçamento ainda. Clique em \"Novo orçamento\" para começar.": "No estimates yet. Click \"New estimate\" to get started.",
  "+{qty} {unit} adicionados": "+{qty} {unit} added",
  "Ajustado para {qty} {unit}": "Adjusted to {qty} {unit}",
  "Ajuste": "Adjust",
  "Ajuste de estoque": "Stock adjustment",
  "Ajuste em {team}": "Adjustment in {team}",
  "Atual:": "Current:",
  "Comprar": "Buy",
  "Confirmar": "Confirm",
  "Descartável": "Disposable",
  "Editar equipamento": "Edit equipment",
  "Editar item": "Edit item",
  "Em estoque": "In stock",
  "Em manutenção": "Under maintenance",
  "Em uso": "In use",
  "Entrada": "Stock in",
  "Entrada de estoque": "Stock in",
  "Equipamento salvo": "Equipment saved",
  "Equipe que Consumiu (opcional)": "Team that consumed (optional)",
  "Estoque Inicial": "Initial stock",
  "Estoque Mínimo": "Minimum stock",
  "Estoque atual:": "Current stock:",
  "Estoque correto": "Correct stock",
  "Ex: 2 anos, 18 meses…": "Ex: 2 years, 18 months…",
  "Ex: Aspirador de pó, Vassoura…": "Ex: Vacuum, Broom…",
  "Ex: Compra Walmart": "Ex: Walmart purchase",
  "Ex: Detergente, Esponja, Pano de microfibra…": "Ex: Detergent, Sponge, Microfiber cloth…",
  "Ex: Home Depot, Amazon…": "Ex: Home Depot, Amazon…",
  "Ex: Lysol, Clorox…": "Ex: Lysol, Clorox…",
  "Ex: Recontagem mensal": "Ex: Monthly recount",
  "Ex: Usado na limpeza Anna Smith": "Ex: Used on Anna Smith cleaning",
  "Histórico de movimentação": "Movement history",
  "Informe a quantidade": "Enter the quantity",
  "Item salvo": "Item saved",
  "Marca": "Brand",
  "Motivo / Observação": "Reason / Note",
  "Movimentação registrada": "Movement recorded",
  "Mínimo": "Minimum",
  "Mínimo:": "Minimum:",
  "Nenhum equipamento cadastrado.": "No equipment registered.",
  "Nenhum item cadastrado.": "No items registered.",
  "Nenhuma movimentação encontrada com esses filtros.": "No movements found with these filters.",
  "Nenhuma movimentação encontrada.": "No movements found.",
  "Nome do Equipamento": "Equipment name",
  "Novo item de limpeza": "New cleaning item",
  "Onde Foi Comprado": "Where it was bought",
  "Produto": "Product",
  "Quantidade ({unit})": "Quantity ({unit})",
  "Quantidade Total": "Total quantity",
  "Químico": "Chemical",
  "Saída": "Stock out",
  "Saída / consumo": "Stock out / usage",
  "Tempo Estimado de Uso": "Estimated usage time",
  "Todos os itens estão acima do estoque mínimo. Nenhuma reposição necessária.": "All items are above the minimum stock. No restock needed.",
  "Total": "Total",
  "Unidade": "Unit",
  "Valor da Compra (US$)": "Purchase value (US$)",
  "distribuído": "distributed",
  "item(ns) precisam de reposição. Sugestão calculada para repor até o dobro do estoque mínimo.": "item(s) need restocking. Suggestion calculated to restock up to twice the minimum stock.",
  "por": "by",
  "un, ml, kg…": "ea, ml, kg…",
  "{qty} alocado à equipe {team}": "{qty} allocated to team {team}",
  "{qty} devolvido da equipe {team}": "{qty} returned from team {team}",
  "−{qty} {unit} consumido": "−{qty} {unit} consumed",
  "−{qty} {unit} consumido por {team}": "−{qty} {unit} consumed by {team}",
  "BAIXO": "LOW",
  "Portal Clean Manager USA": "Clean Manager USA Portal",
  "Portal do Cliente": "Client Portal",
  "Acesse seu histórico, recibos e orçamentos.": "Access your history, receipts and estimates.",
  "Não tem acesso? Solicite ao seu gestor para liberar o portal.": "No access? Ask your manager to enable the portal.",
  "Login falhou": "Login failed",
  "Olá, {name}!": "Hello, {name}!",
  "Minha Agenda": "My Schedule",
  "Recibos": "Receipts",
  "Orçamentos": "Estimates",
  "Idioma": "Language",

  // ── Estimate PDF ─────────────────────────────────────────────────────────
  "Formulário de orçamento": "Estimate form",
  "Dados do orçamento": "Estimate details",
  "Nº do orçamento": "Estimate #",
  "Validade": "Valid until",
  "Tarifas propostas": "Proposed rates",
  "Outra": "Other",
  "Assinatura": "Signature",
  "gerado em": "generated on",

  // ── Backend error messages (HTTPException details) ───────────────────────
  "Algo deu errado. Tente novamente.": "Something went wrong. Please try again.",
  "Acesso negado": "Access denied",
  "Acesso restrito": "Restricted access",
  "Apenas admin pode criar notas pessoais": "Only admins can create personal notes",
  "Apenas imagens": "Images only",
  "Arquivo maior que 10MB": "File larger than 10MB",
  "Arquivo não encontrado": "File not found",
  "Cada regra precisa ter uma data OU dias da semana.": "Each rule must have a date OR weekdays.",
  "Cliente inválido": "Invalid client",
  "Cliente não encontrado": "Client not found",
  "Cliente precisa ter e-mail cadastrado": "Client must have a registered email",
  "Cliente sem coordenadas GPS": "Client without GPS coordinates",
  "Colaborador não encontrado": "Collaborator not found",
  "Colaborador sem dias de trabalho definidos": "Collaborator without defined workdays",
  "Configure o webhook primeiro": "Set up the webhook first",
  "Convite ainda não foi preenchido": "Invitation has not been filled out yet",
  "Convite não encontrado": "Invitation not found",
  "Convite não preenchido ou já tratado": "Invitation not filled out or already handled",
  "Credenciais inválidas": "Invalid credentials",
  "Código inválido ou expirado": "Invalid or expired code",
  "Data inválida": "Invalid date",
  "Data ou hora inválida": "Invalid date or time",
  "E-mail já cadastrado": "Email already registered",
  "E-mail já em uso por outro usuário": "Email already in use by another user",
  "E-mail já utilizado por outro colaborador": "Email already used by another collaborator",
  "E-mail obrigatório": "Email required",
  "E-mail ou nome com padrão de conta de teste não é permitido.": "Email or name with a test-account pattern is not allowed.",
  "Email obrigatório": "Email required",
  "Emergent não retornou email": "Emergent did not return an email",
  "Empresa não encontrada": "Company not found",
  "Envie 'ids' com a lista de clientes a remover.": "Send 'ids' with the list of clients to remove.",
  "Envie 'ids' com a lista de usuários a remover.": "Send 'ids' with the list of users to remove.",
  "Equipamento em uso por alguma equipe": "Equipment in use by a team",
  "Equipamento inválido": "Invalid equipment",
  "Equipe inválida": "Invalid team",
  "Equipe não encontrada": "Team not found",
  "Esta conta foi criada com Google. Use o botão 'Entrar com Google'.": "This account was created with Google. Use the 'Sign in with Google' button.",
  "Este link expirou": "This link has expired",
  "Este é o único admin da empresa. Promova outro antes de alterar.": "This is the company's only admin. Promote another before changing.",
  "Falha ao postar no webhook do Teams": "Failed to post to the Teams webhook",
  "Falha ao validar sessão Google": "Failed to validate Google session",
  "Formato esperado YYYY-MM-DD": "Expected format YYYY-MM-DD",
  "Galeria indisponível": "Gallery unavailable",
  "Informe a senha atual": "Enter your current password",
  "Item não encontrado": "Item not found",
  "Já existe um cargo com este nome": "A position with this name already exists",
  "Já existe um usuário com esse e-mail. Use outro.": "A user with this email already exists. Use another.",
  "Já existe usuário com esse e-mail": "A user with this email already exists",
  "Limpeza já encerrada": "Cleaning already closed",
  "Limpeza não está em andamento": "Cleaning is not in progress",
  "Link inválido": "Invalid link",
  "Nada para atualizar": "Nothing to update",
  "Nota não encontrada": "Note not found",
  "Não autenticado": "Not authenticated",
  "Não autorizado": "Not authorized",
  "Não encontrado": "Not found",
  "Não foi possível geocodificar este endereço": "Could not geocode this address",
  "Não é possível excluir um admin": "Cannot delete an admin",
  "Não é possível excluir um super-admin": "Cannot delete a super-admin",
  "Orçamento não encontrado": "Estimate not found",
  "Pagamentos indisponíveis (key ausente)": "Payments unavailable (missing key)",
  "Permissão negada": "Permission denied",
  "Plano inválido": "Invalid plan",
  "Plano não encontrado": "Plan not found",
  "Plano & Cobrança": "Plan & Billing",
  "Materiais com a equipe": "Team materials",
  "Equipamentos sob responsabilidade da sua equipe (somente leitura).": "Equipment your team is responsible for (read-only).",
  "Nenhum equipamento atribuído à sua equipe.": "No equipment assigned to your team.",
  "Material de limpeza": "Cleaning supplies",
  "Avise quando um material estiver acabando ou tiver acabado. O admin é notificado para comprar.": "Flag when a supply is running low or has run out. The admin is notified to buy it.",
  "Nenhum material cadastrado.": "No supplies registered.",
  "Acabando": "Running low",
  "Acabou": "Out of stock",
  "Cancelar aviso": "Cancel alert",
  "Avisado: material acabou": "Reported: out of stock",
  "Avisado: material acabando": "Reported: running low",
  "Aviso cancelado": "Alert canceled",
  "Avisos dos colaboradores": "Staff alerts",
  "Materiais que os líderes avisaram que estão acabando ou acabaram. Marque como comprado após repor.": "Supplies your team leaders flagged as low or out. Mark as bought after restocking.",
  "Marcar como comprado": "Mark as bought",
  "Marcado como comprado": "Marked as bought",
  "Comprado e estoque atualizado": "Bought and stock updated",
  "Quantidade comprada (opcional)": "Quantity bought (optional)",
  "Se informar, entra automaticamente no estoque. Deixe em branco para apenas marcar como comprado.": "If provided, it's added to stock automatically. Leave blank to just mark as bought.",
  "A Receber": "Accounts Receivable",
  "Cada casa finalizada vira um item. Junte os itens de um cliente em uma fatura única para uma só cobrança.": "Each finished home becomes an item. Combine a client's items into a single invoice for one charge.",
  "Itens pendentes (total)": "Pending items (total)",
  "cliente(s)": "client(s)",
  "Faturas em aberto": "Open invoices",
  "fatura(s)": "invoice(s)",
  "Pendentes por cliente": "Pending by client",
  "Faturas": "Invoices",
  "Nenhum item pendente. Finalize casas para gerar itens de fatura.": "No pending items. Finish homes to generate invoice items.",
  "item(ns)": "item(s)",
  "desde": "since",
  "Gerar fatura": "Generate invoice",
  "Nenhuma fatura gerada ainda.": "No invoices generated yet.",
  "Paga": "Paid",
  "Fatura": "Invoice",
  "Baixa em": "Settled on",
  "Dar baixa": "Mark as paid",
  "Excluir fatura?": "Delete invoice?",
  "Os itens voltarão para 'pendente' e poderão ser faturados novamente.": "Items will return to 'pending' and can be invoiced again.",
  "Fatura excluída": "Invoice deleted",
  "Juntar tudo": "Combine all",
  "Escolher período": "Choose period",
  "Nenhum item pendente neste período.": "No pending items in this period.",
  "Total da fatura": "Invoice total",
  "Nenhum item no período selecionado": "No items in the selected period",
  "Fatura #{n} gerada — {v}": "Invoice #{n} generated — {v}",
  "Falha ao gerar fatura": "Failed to generate invoice",
  "Baixa registrada": "Payment recorded",
  "Falha ao dar baixa": "Failed to settle",
  "Forma de pagamento": "Payment method",
  "Data do pagamento": "Payment date",
  "Confirmar baixa": "Confirm payment",
  "Portal desativado para este cliente": "Portal disabled for this client",
  "Preço não pode ser negativo": "Price cannot be negative",
  "Quantidade deve ser maior que zero": "Quantity must be greater than zero",
  "Quantidade entre 1 e 60": "Quantity between 1 and 60",
  "Refresh ausente": "Refresh token missing",
  "Sem permissão": "No permission",
  "Senha atual incorreta": "Current password is incorrect",
  "Senha deve ter pelo menos 6 caracteres": "Password must be at least 6 characters",
  "Senha do admin incorreta": "Admin password is incorrect",
  "Sessão Google inválida ou expirada": "Invalid or expired Google session",
  "Sessão expirada": "Session expired",
  "Solicitação não encontrada": "Request not found",
  "Status inválido": "Invalid status",
  "Storage indisponível": "Storage unavailable",
  "Só é possível reverter limpezas em andamento.": "You can only revert cleanings in progress.",
  "Template não encontrado": "Template not found",
  "Tenant não encontrado": "Tenant not found",
  "Tipo inválido": "Invalid type",
  "Token inválido": "Invalid token",
  "Token inválido ou expirado": "Invalid or expired token",
  "Transação não encontrada": "Transaction not found",
  "Use o portal interno": "Use the internal portal",
  "Usuário não encontrado": "User not found",
  "Você não faz parte da equipe deste job": "You are not part of this job's team",
  "Webhook inválido": "Invalid webhook",
  "days deve estar entre 1 e 365": "days must be between 1 and 365",
  "entity_id é obrigatório": "entity_id is required",
  "mode deve ser 'manual' ou 'auto'": "mode must be 'manual' or 'auto'",
  "session_id obrigatório": "session_id required",
  "user_id é obrigatório": "user_id is required",

  // ── Portal — páginas internas ─────────────────────────────────────────────
  "Agendado": "Scheduled",
  "Concluído": "Completed",
  "Cancelado": "Canceled",
  "Pendente": "Pending",
  "Bem-vindo,": "Welcome,",
  "Aqui você acompanha sua agenda, recibos e orçamentos.": "Here you can track your schedule, receipts and estimates.",
  "Próximos serviços": "Upcoming services",
  "Serviços concluídos": "Completed services",
  "Total gasto": "Total spent",
  "Total serviços": "Total services",
  "Próximo serviço": "Next service",
  "Ver toda a agenda →": "View full schedule →",
  "Você não tem nenhum serviço agendado no momento.": "You have no scheduled service at the moment.",
  "Nenhum serviço cadastrado ainda.": "No services registered yet.",
  "finalizado em": "finished on",
  "Você ainda não tem serviços concluídos.": "You don't have completed services yet.",
  "serviços concluídos": "completed services",
  "Pago": "Paid",
  "Nenhum orçamento vinculado ao seu e-mail.": "No estimates linked to your email.",
  "Selecione uma data preferida": "Select a preferred date",
  "Solicitação enviada! Vamos te responder em breve.": "Request sent! We'll get back to you soon.",
  "Erro ao enviar solicitação": "Error sending request",
  "Solicitar Agendamento": "Request a Booking",
  "Escolha sua data preferida e envie a solicitação. Vamos confirmar em até 48h.": "Choose your preferred date and send the request. We'll confirm within 48h.",
  "— sem preferência —": "— no preference —",
  "Frequência desejada": "Desired frequency",
  "— a definir —": "— to be defined —",
  "Observações (opcional)": "Notes (optional)",
  "Conte qualquer detalhe importante (cômodos extras, acesso, pets…)": "Tell us any important detail (extra rooms, access, pets…)",
  "Enviando…": "Sending…",
  "Enviar solicitação": "Send request",
  "Suas solicitações": "Your requests",
  "Você ainda não fez nenhuma solicitação.": "You haven't made any requests yet.",
  "Resposta:": "Reply:",
  "Recusado": "Rejected",
  "Novo local de acesso": "New login location",
};
